import classNames from 'classnames';
import WidgetIdWrapper from './WidgetIdWrapper';
import { withWidgetSpacingWrapper } from './WidgetSpacingWrapper';

const Content = (props) => {
  const { text, type, icon, replacementTertiaryIcon, tertiaryIconHasBackground, isExternal } =
    props;

  return (
    <>
      {type === 'icon' ? (
        <>
          <span className="material-icons-outlined" aria-hidden="true">
            {icon}
          </span>
          <span className="btn-icon-text">{text}</span>
        </>
      ) : (
        <>
          <span>
            {text}
            {isExternal ? (
              <div
                className="material-icons-outlined external-link-indicator"
                style={{ marginLeft: '6px', fontSize: '20px', marginRight: '0' }}
              >
                open_in_new
              </div>
            ) : (
              ''
            )}
          </span>
        </>
      )}
      {type === 'tertiary' && !isExternal && (
        <span className="material-icons-round">{replacementTertiaryIcon || 'chevron_right'}</span>
      )}
      {type === 'icon-tertiary' && (
        <span
          className={classNames('icon-wrapper', { 'has-background': tertiaryIconHasBackground })}
        >
          <span className="material-icons-outlined">{icon}</span>
        </span>
      )}
    </>
  );
};

const ButtonLink = (props) => {
  const {
    id,
    ariaLabelledBy,
    className,
    isDisabled = false,
    text,
    link,
    buttonLinkMailOrPhone,
    onClickFunction,
    replacementTertiaryIcon = '',
    target,
    isExternal,
    type,
    size,
    theme,
    icon,
    alignment,
    widgetID,
    isPrintButton,
    isButtonTag = false,
    tertiaryIconHasBackground = true,
    useWidgetIdWrapper = true,
    ariaAttributes = {}
  } = props;

  const printOnClick = () => {
    window.print();
    return false;
  };

  return (
    <>
      {useWidgetIdWrapper ? (
        <WidgetIdWrapper widgetID={widgetID} withServerStylesConditionalWrapper={false}>
          <div className={classNames('btn-wrapper', { [`${className}`]: className })}>
            {!isButtonTag ? (
              <a
                href={link != null && link.length > 0 ? link : buttonLinkMailOrPhone}
                target={target}
                className={`non-default-link btn btn-${type} btn-${type}-${size} btn-${theme}-theme btn-align-${alignment}`}
                onClick={onClickFunction}
                {...(isPrintButton && { onClick: printOnClick })}
                {...ariaAttributes}
              >
                <Content
                  replacementTertiaryIcon={replacementTertiaryIcon}
                  tertiaryIconHasBackground={tertiaryIconHasBackground}
                  text={text}
                  type={type}
                  icon={icon}
                  isExternal={isExternal}
                />
              </a>
            ) : (
              <button
                className={`non-default-link btn btn-${type} btn-${type}-${size} btn-${theme}-theme btn-reset btn-align-${alignment}`}
                {...(isPrintButton && { onClick: printOnClick })}
                onClick={onClickFunction}
                aria-labelledby={ariaLabelledBy}
                {...ariaAttributes}
                disabled={isDisabled}
                id={id}
              >
                {type === 'plain-link' ? (
                  <span className="btn-plain-link-text">{text}</span>
                ) : (
                  <Content
                    replacementTertiaryIcon={replacementTertiaryIcon}
                    text={text}
                    type={type}
                    icon={icon}
                  />
                )}
              </button>
            )}
          </div>
        </WidgetIdWrapper>
      ) : (
        <div className={classNames('btn-wrapper', { [`${className}`]: className })}>
          {!isButtonTag ? (
            <a
              href={link != null && link.length > 0 ? link : buttonLinkMailOrPhone}
              target={target}
              id={id}
              className={`non-default-link btn btn-${type} btn-${type}-${size} btn-${theme}-theme btn-align-${alignment}`}
              onClick={onClickFunction}
              {...(isPrintButton && { onClick: printOnClick })}
              {...ariaAttributes}
            >
              <Content
                replacementTertiaryIcon={replacementTertiaryIcon}
                tertiaryIconHasBackground={tertiaryIconHasBackground}
                text={text}
                type={type}
                icon={icon}
              />
            </a>
          ) : (
            <button
              className={`non-default-link btn btn-${type} btn-${type}-${size} btn-${theme}-theme btn-reset btn-align-${alignment}`}
              {...(isPrintButton && { onClick: printOnClick })}
              onClick={onClickFunction}
              aria-labelledby={ariaLabelledBy}
              {...ariaAttributes}
              disabled={isDisabled}
              id={id}
            >
              {type === 'plain-link' ? (
                <span className="btn-plain-link-text">{text}</span>
              ) : (
                <Content
                  replacementTertiaryIcon={replacementTertiaryIcon}
                  text={text}
                  type={type}
                  icon={icon}
                />
              )}
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default withWidgetSpacingWrapper(ButtonLink);
